import { createSlice } from "@reduxjs/toolkit";

const ManageUserRoleSlice = createSlice({
  name: "manageUserRole",
  initialState: {
    isLoading: false,
    error: null,
    allUserRoleList: [],
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAllUserRoleList: (state, action) => {
      state.allUserRoleList = action.payload;
    },
  },
});

export const { setLoading, setError, setAllUserRoleList } =
  ManageUserRoleSlice.actions;

export default ManageUserRoleSlice.reducer;
